import { faComments } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function ChannelNotSelected() {
  return (
    <div className='flex flex-col items-center justify-center bg-light_gray dark:bg-dk-bg w-full rounded-tl-xl gap-4'>
      <FontAwesomeIcon icon={faComments} size='8x' className='text-gray dark:text-gray-400' />
      <p className='text-center text-gray dark:text-gray-400 text-base'>Seleccioná un chat para empezar a hablar</p>
    </div>
  )
}